import React, {useEffect, useState} from "react";
import {Link, useSearchParams} from "react-router-dom";
import {postDanai} from "../../util/ajax";
import Moment from 'moment';

function PromoDetailPage() {
    useEffect(() => window.scrollTo(0, 0), []);
    const [searchParams] = useSearchParams();
    const id = searchParams.get("id");

    const [promoEvent, setPromoEvents] = useState([])
    useEffect(() => {
        postDanai(process.env.REACT_APP_MOBILE_API_URL + '/p2p-mobile-api/rest/customerWeb/promoEvents', function (resp) {
            console.log(resp);
            setPromoEvents(resp.data);
        }, function () {
        });
    }, []);

    return (
        <div>
            {promoEvent.filter(data => data.id === id).map(promo => (
                <div>
                    <div className="breadcrumb-wrapper-promo-detail">
                        <div className="general-container">
                            <div className="ui-g-6">
                                <h1>
                                    {promo.title}
                                </h1>
                                <p className="createDate">
                                    {Moment(promo.createdTimestamp).format('DD MMMM yyyy')}
                                </p>
                            </div>
                            <div className="ui-g-6">
                                <ul className="breadcrumb">
                                    <li><Link to="/">Beranda</Link></li>
                                    <li><a href={() => false}>Media Informasi</a></li>
                                    <li>
                                        {promo.title}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div>
                        <img className="image-article" src={promo.imageUrl} alt="new"/>
                    </div>
                    <article className="describe-promo">
                        <div className="general-container">
                            <div dangerouslySetInnerHTML={{__html: promo.content}}/>
                            <div className="spanHastag"
                                 dangerouslySetInnerHTML={{__html: (promo.hashtag.replaceAll("#", "<span>#").replaceAll(";", "</span> "))}}/>
                        </div>
                    </article>
                </div>
            ))}
        </div>
    );
}

export default PromoDetailPage;